export const riskEntities = {
  nosis: {
    id: 'NOSIS',
    label: 'NOSIS',
  },
  bpb: {
    id: 'BPB',
    label: 'BPB',
  },
  casfog: {
    id: 'CASFOG',
    label: 'CASFOG',
  },
  bcra: {
    id: 'CASFOG',
    label: 'BCRA',
  },
};
